import BMenuViewComponent from '../views/b-menu-view'

import StoreHelper from '../store/helper'
import RouterHelper from './RouterHelper'

import _ from 'lodash'

class ViewManager {
  static createParentView (name, path = null, data = {}) {
    if (_.isNull(path)) {
      const route = RouterHelper.extractCurrentRoute(StoreHelper.getRouter())
      path = RouterHelper.extractParentRoutePath(route)
    }

    ViewManager.createView(name, path, data)
  }

  static createChildView (name, path = null, data = {}) {
    if (_.isNull(path)) {
      const route = RouterHelper.extractCurrentRoute(StoreHelper.getRouter())
      path = RouterHelper.createSubRoutePath(route, name)
    }

    ViewManager.createView(name, path, data)
  }

  static createView (name, path, data = {}) {
    const router = StoreHelper.getRouter()

    if (RouterHelper.routeExists(router, { path })) {
      return RouterHelper.goTo(router, { path })
    }

    const view = ViewManager.getMenuViewComponent(data)
    const route = RouterHelper.createMenuViewRoute(name, path, view)

    RouterHelper.attachRoute(router, StoreHelper.getInitialRouteName(), route)
    RouterHelper.goTo(router, { path })
  }

  static getMenuViewComponent (data) {
    return this.injectData(_.cloneDeep(BMenuViewComponent), data)
  }

  static injectData (view, data) {
    const viewData = { ...view.data(), ...data }
    view.data = () => viewData
    return view
  }

  static addItemsToView (path, items) {
    const view = StoreHelper.getViewByPath(path)
    if (view) {
      view.addMenuItems(_.concat([], items))
    }
  }

  static replaceOrAddItemInView (path, item) {
    ViewManager.replaceItemInActiveView(item)

    // TODO: Pass path instead of name
    const view = StoreHelper.getViewByPath(path)
    if (view) {
      view.replaceOrAddMenuItem(item)
    }
  }

  static replaceItemInActiveView (item) {
    const activeViewItem = ViewManager.getActiveViewItem() || { id: null }

    if (_.isEqual(activeViewItem.id, item.id)) {
      StoreHelper.getActiveView().updateParent(item)
    }
  }

  static removeItemFromView (path, identifier) {
    // TODO: Pass path instead of name
    const view = StoreHelper.getViewByPath(path)
    if (view) {
      view.removeMenuItem(identifier)
    }
  }

  static viewExists (name) {
    return _.has(StoreHelper.getViews(), name)
  }

  static getActiveViewItem () {
    return _.get(StoreHelper.getActiveView(), 'parent', null)
  }
}

export default ViewManager
